import { z } from "zod";

export const FORCE_COMPLETE_ATTEMPT_TYPE = "FORCE_COMPLETE";

export const ForceCompleteTaskAttemptSchema = z.object({
  type: z.literal(FORCE_COMPLETE_ATTEMPT_TYPE),
  reason: z.string().trim().min(1),
});
